<template>
  <el-card style="height: 100%; overflow: auto" class="box-card">
    <el-row>
      <el-col :span="8">
        <el-row class="lineStyle">
          <el-col :span="12">
            <h2 style="font-size: 32px">资料归档管理</h2>
          </el-col>
          <el-col :span="12">
            <el-button size="small" type="success" @click="changeFileType(1)"
              >BIM模型</el-button
            ><el-button size="small" type="primary" @click="changeFileType(3)"
              >图纸</el-button
            ><el-button size="small" type="info" @click="changeFileType(4)"
              >文档</el-button
            >
          </el-col>
        </el-row>
        <!-- echarts -->
        <v-chart
          theme="macarons"
          style="width: 100%; padding-right: 20px"
          :options="polar"
        />
        <!-- table -->
        <el-table :data="fileTable" border v-loading="TableLoading">
          <el-table-column prop="zwpm03" label="文件名称" align="center">
            <template slot-scope="scope">
              <el-button
                @click="viewShow(scope.row)"
                size="mini"
                :type="
                  scope.row.zwpm08 == 3
                    ? 'primary'
                    : scope.row.zwpm08 == 4
                    ? 'info'
                    : 'success'
                "
                >{{ scope.row.zwpm03 }}</el-button
              >
            </template>
          </el-table-column>
          <el-table-column prop="user04" label="上传人" align="center">
          </el-table-column>
          <el-table-column prop="zwpm07" label="上传时间" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="downloadFiles(scope.row)"
                type="primary"
                >下载</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 20px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagenum"
          :page-sizes="[100, 50, 10]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-col>
      <el-col :span="16">
        <el-row class="lineStyle">
          <el-col :span="8">
            <el-input
              v-model="searchword"
              placeholder="请输入计划名称"
              class="search-input"
            ></el-input>
            <el-button
              icon="el-icon-search"
              @click="GetProjectPlan"
            ></el-button>
          </el-col>
          <el-col :span="8" class="flex">
            <div>计划：</div>
            <el-select
              @change="changePlan"
              style="width: 80%"
              v-model="planId"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in planList"
                :key="item.zwpp01"
                :label="item.zwpp03"
                :value="item.zwpp01"
              >
              </el-option> </el-select
          ></el-col>
          <el-col :span="6" class="flex">
            <div>负责人：</div>
            <el-select
              style="width: 60%"
              @change="changeUser"
              v-model="userId"
              filterable
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in userlist"
                :key="item.user01"
                :label="item.user04"
                :value="item.user01"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <!-- modelShow -->
        <div v-show="modelShow" id="MyViewerDiv" class="model"></div>
        <div v-show="documentShow" style="margin-top: 30px">
          <iframe
            width="100%"
            height="800px"
            :src="iframeUrl"
            frameborder="0"
          ></iframe>
        </div>
        <div v-show="fileTable.length == 0" style="margin-top: 30px">
          <h2>暂无数据展示</h2>
        </div>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import {
  GetProjectPlan,
  TaskResultChart,
  GetPlanUploader,
  GetPlanFiles,
  Office2Pdf,
} from "@/setAxios";
export default {
  data() {
    return {
      planList: [],
      userlist: [],
      myFiles: {},
      planId: 0,
      userId: "",
      fileType: 1,
      fileTable: [],
      TableLoading: false,
      searchword: "",
      pageSize: 10,
      pagenum: 1,
      total: 0,
      pageIndex: 1,
      query: "",
      polar: {},
      modelShow: false,
      documentShow: false,
      iframeUrl: "",
      //---
    };
  },
  created() {
    this.GetProjectPlan();
  },
  methods: {
    changeFileType(data) {
      this.documentShow = false;
      this.modelShow = false;
      this.fileType = data;
      this.GetPlanFiles();
    },
    viewShow(data) {
      if (this.fileTable.length > 0) {
        if (this.fileType == 1 || this.fileType == 3) {
          this.documentShow = false;
          this.modelShow = true;
          var data = {
            url: this.$store.state.baseUrl + data.zwpm04,
            modelId: data.zwpm01,
            cid: localStorage.pid,
            xid: localStorage.xid,
            type: 1,
          };
          this.viewers(data);
        } else {
          this.modelShow = false;
          this.documentShow = true;
          this.Office2Pdf(this.fileTable[0].zwpm04);
        }
      } else {
        this.documentShow = false;
        this.modelShow = false;
      }
    },
    viewers(data) {
      this.modelLoad = false;
      this.$nextTick(() => {
        ZJWJ.LoadModel(data);
        var Interval = setInterval(() => {
          if (ZJWJ.modelLoad) {
            clearInterval(Interval);
            this.modelLoad = true;
          }
        }, 500);
      });
    },
    downloadFiles(data) {
      if (data.downPath) {
        let aNode = document.createElement("a");
        aNode.target = "_blank";
        aNode.href = `${this.$store.state.baseUrl}/api/PlanFileDownLoad?id=${data.zwpm01}&name=${data.zwpm03}&token=${localStorage.token}`;
        aNode.click();
      } else {
        this.$message({
          type: "warning",
          message: "无法下载",
        });
      }
    },
    changeUser() {
      this.documentShow = false;
      this.modelShow = false;
      this.TaskResultChart();
      this.GetPlanFiles();
    },
    changePlan() {
      this.documentShow = false;
      this.modelShow = false;
      this.GetPlanUploader();
      this.TaskResultChart();
      this.GetPlanFiles();
    },
    async GetProjectPlan() {
      this.documentShow = false;
      this.modelShow = false;
      let params = {
        xid: localStorage.xid,
      };
      let res = await GetProjectPlan({ params });
      this.planList = res.Data;
      if (res.Data.length > 0) {
        this.planId = res.Data[0].zwpp01;
        this.GetPlanUploader();
        this.TaskResultChart();
        this.GetPlanFiles();
      }
    },
    async TaskResultChart() {
      let params = {
        planId: this.planId,
        userId: this.userId,
      };
      let res = await TaskResultChart({ params });
      this.myFiles = res.Data;
      this.polar = {
        colors: ["red", "green", "yellow"],
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          right: 0,
          top: "10%",
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: ["40%", "60%"],
            data: [
              { value: res.Data.BIMSum, name: "BIM模型" },
              { value: res.Data.CADSum, name: "CAD图纸" },
              { value: res.Data.DocumentSm, name: "文档" },
            ],
          },
        ],
      };
    },
    async GetPlanUploader() {
      let params = {
        planId: this.planId,
      };
      let res = await GetPlanUploader({ params });
      this.userlist = res.Data;
    },
    async Office2Pdf(data) {
      let res = await Office2Pdf({ sourcePath: data });
      if (res.Code === 0) {
        this.$message({
          type: "warning",
          message: res.Message,
        });
      } else {
        this.iframeUrl = this.$store.state.baseUrl + res.Data;
      }
    },
    async GetPlanFiles() {
      this.TableLoading = true;
      let params = {
        planId: this.planId,
        userId: this.userId,
        type: this.fileType,
        searchword: this.searchword,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
      };
      let res = await GetPlanFiles({ params });
      this.fileTable = res.Data.list;
      this.total = res.Data.total;
      // if (this.fileTable.length > 0) {
      //   if (this.fileType == 1 || this.fileType == 3) {
      //     this.documentShow = false;
      //     this.modelShow = true;
      //     this.viewShow(this.fileTable[0]);
      //   } else {
      //     this.modelShow = false;
      //     this.documentShow = true;
      //     this.Office2Pdf(this.fileTable[0].zwpm04);
      //   }
      // } else {
      //   this.documentShow = false;
      //   this.modelShow = false;
      // }
      this.TableLoading = false;
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.pagenum = val;
    },
  },
};
</script>

<style lang="less" scoped>
.model {
  position: absolute;
  margin-top: 30px;
  width: 58vw;
  height: 80vh;
}
.lineStyle {
  height: 32px;
  line-height: 32px;
}

.flex {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.flexbetween {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-input {
  width: 300px;
}
</style>